/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import compose from 'recompose/compose';
import { Input, InputAdornment } from '@material-ui/core';
import { Magnify } from 'mdi-material-ui';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import { connect } from 'react-redux';
import GridItem from '../Grid/GridItem';
import SearchNull from '../Adescom/SearchNull';
import GridContainer from '../Grid/GridContainer';
import Grid from '@material-ui/core/Grid';

interface SearchCellInputTextProps {
    dispatch: any;
    classes: any;
    inputType: InputType;
    fieldName: string;
    setStringToUpper?: boolean;

    updateCallback(fieldName: string, value: string): void;

    searchActionCallback(): void;

    clearField?: boolean;
    nullable?: boolean;
    autoComplete?: string;

    filterItemManage?: {key: string, value: string, rawValue: string | null, shouldRemove: boolean};
}

interface SearchCellInputTextState {
    prevValue: number | string | null;
    minValueLength: number;
    hasValue: boolean;
    currentValue: string | number | null;
}

type InputType = 'string' | 'number' | 'email' | 'zip' | 'phone';

const textLengthMap = {
    string: 3,
    number: 1,
    email: 3,
    zip: 2,
    phone: 3,
};

class SearchCellInputText extends PureComponent<SearchCellInputTextProps, SearchCellInputTextState> {
    constructor(props: SearchCellInputTextProps, context: SearchCellInputTextState) {
        super(props, context);

        this.state = {
            prevValue: null,
            minValueLength: textLengthMap[this.props.inputType],
            hasValue: false,
            currentValue: '',
        };
    }

    componentDidUpdate(prevProps: Readonly<SearchCellInputTextProps>, prevState: Readonly<SearchCellInputTextState>, snapshot?: any): void {
        const { clearField, dispatch, filterItemManage } = this.props;
        const { hasValue } = this.state;
        if(filterItemManage && this.props.fieldName === filterItemManage.key && this.state.currentValue === filterItemManage.value) {
            this.clearInput();
        }
        if (hasValue && clearField) {
            this.clearInput();
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    clearInput = (): void => {
        this.setState({
            prevValue: '',
            hasValue: false,
            currentValue: '',
        });
    };

    inputStyle = (value?: any): object => {
        const styleAppendix: { opacity?: string; color?: string; unselectable?: string } = {};
        if (value === 'null') {
            styleAppendix.color = 'rgba(0,0,0,0)';
        }
        return { fontSize: '10px', height: 32, minWidth: '100px', ...styleAppendix };
    };

    actionChange = (e: any): void => {
        const { searchActionCallback } = this.props;
        if (e.key === 'Enter' && searchActionCallback) {
            searchActionCallback();
        }
    };

    onChange = (e: any): void => {
        const { updateCallback, fieldName, dispatch, setStringToUpper } = this.props;
        let currentValue = '';

        if (typeof e === 'string') {
            currentValue = e;
        } else {
            currentValue = e.target.value;
        }
        this.setState({ currentValue: currentValue, prevValue: currentValue, hasValue: currentValue.length > 0 }, (): void => {
            if (setStringToUpper) {
                currentValue = currentValue.toUpperCase();
            }
            updateCallback(fieldName, currentValue);
            dispatch({
                type: 'headerFilterManage',
                headerFilterElementName: fieldName,
                headerFilterElementHasValue: currentValue.length > 0,
            });
        });
    };

    render(): React.ReactNode {
        const { inputType, nullable, fieldName, autoComplete } = this.props;
        const { currentValue } = this.state;

        switch (inputType) {
            case 'string':
            case 'email':
            case 'zip':
            case 'phone':
                return (
                    <GridContainer>
                        {nullable && (
                            <GridItem xs={3} style={{ position: 'relative' }}>
                                <SearchNull fieldName={fieldName} value={currentValue} updateCallback={this.onChange} />
                            </GridItem>
                        )}
                        <Grid item xs={nullable ? 9 : 12}>
                            <Input
                                type="text"
                                disabled={currentValue === 'null'}
                                style={this.inputStyle(currentValue)}
                                onChange={this.onChange}
                                onKeyPress={this.actionChange}
                                autoComplete={autoComplete}
                                value={currentValue}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <Magnify fontSize={'small'} />
                                    </InputAdornment>
                                }
                            />
                        </Grid>
                    </GridContainer>
                );
            case 'number':
                return (
                    <GridContainer>
                        {nullable && (
                            <Grid item xs={3}>
                                <SearchNull fieldName={fieldName} value={currentValue} updateCallback={this.onChange} />
                            </Grid>
                        )}
                        <Grid item xs={nullable ? 9 : 12} style={{ paddingLeft: nullable ? '10px' : '0px' }}>
                            <Input
                                type="number"
                                disabled={currentValue === 'null'}
                                style={this.inputStyle(currentValue)}
                                onChange={this.onChange}
                                onKeyPress={this.actionChange}
                                autoComplete={autoComplete}
                                value={currentValue}
                                startAdornment={
                                    <InputAdornment position="start">
                                        <Magnify fontSize={'small'} />
                                    </InputAdornment>
                                }
                            />
                        </Grid>
                    </GridContainer>
                );
            default:
                break;
        }
        return null;
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if(filterReducer && filterReducer.type === FilterReducerFieldName.HEADER_FILTER_MANAGE_ELEMENT) {
        return {
            filterItemManage: filterReducer.filterItemManage
        }
    }
    if (filterReducer && filterReducer.clearAll) {
        return {
            clearField: true,
        };
    }
    return {};
};
export default compose<any, any>(connect(stateToProps), withStyles(adescomStyle))(SearchCellInputText);
